module.exports = __webpack_public_path__ + "media/images/icon/tel-cce1177eb33902b7757c47fd9b596632.svg";